import {GET, POST} from "@/services/gateway";

const list = ({pagination, search, filter}) => {
  return POST('dropbox/shared-folder/list', {pagination, search, filter});
}

const getStatus = () => {
  return GET('dropbox/shared-folder/status');
}

const refresh = () => {
  return GET('dropbox/shared-folder/refresh');
}

const backupAll = () => {
  return GET('dropbox/shared-folder/backup/all')
}

const backupAllActiveSeats = () => {
  return GET('dropbox/shared-folder/backup/active-seats')
}

const protectAll = () => {
  return POST('dropbox/shared-folder/protect');
}

const unprotectAll = () => {
  return POST('dropbox/shared-folder/unprotect');
}

const changeStatus = ({status, id}) => {
  return POST('dropbox/shared-folder/status/change', {status, id});
}

const exportSnapshot = (filter, search, pagination) => {
  const currentDate = new Date();

  return POST('dropbox/shared-folder/export', {
    filter,
    search,
    pagination,
    TimeZoneOffset: currentDate.getTimezoneOffset()
  })
}

export {
  list,
  refresh,
  getStatus,
  protectAll,
  unprotectAll,
  backupAllActiveSeats,
  backupAll,
  changeStatus,
  exportSnapshot
}
